import React, { useEffect } from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import { isLogin } from '../utils';
import {
    hasRouteAccess, isRouteAccessReady, registerRoutePath, shouldLogDenial
} from '../utils/routeAccess';
import HttpService from '../services/httpService';
import PageNotFound from './pageNotFound';

const AccessLoading = () => (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40vh' }}>
        <CircularProgress />
    </div>
);

const DeniedPage = ({ path }) => {
    const location = useLocation();

    useEffect(() => {
        if (!shouldLogDenial(path)) return;
        HttpService.logDeniedRoute(path, location.pathname).catch(() => { });
    }, [path, location.pathname]);

    return <PageNotFound />;
};

const PrivateRoute = ({ component: Component, ...rest }) => {
    const { routeAccess } = useSelector(state => state.user)

    registerRoutePath(rest.path, rest.exact)

    return (
        <Route {...rest} render={props => {
            if (!isLogin()) return <Redirect to="/" />

            if (!isRouteAccessReady(routeAccess) && routeAccess && routeAccess.status === 'loading') {
                return <AccessLoading />
            }

            if (!hasRouteAccess(rest.path, rest.exact, routeAccess)) {
                const listAvailable = isRouteAccessReady(routeAccess)
                return listAvailable
                    ? <DeniedPage path={Array.isArray(rest.path) ? rest.path[0] : rest.path} />
                    : <PageNotFound />
            }

            return <Component {...props} />
        }} />
    );
};

export default PrivateRoute;
